export default __webpack_public_path__ + "static/media/choose-fb-pages-fr.603c9b4c.png";